import { EAppModule } from "dto/EAppModule";

/**
 * Funkcje aplikacji (pozycje menu i ich podpozycje). Kontrakt z BE:
 * Kwantum.LegalMail.Data/Access/AppFunctions.cs — zmieniać tylko razem.
 *
 * BE zwraca w /ui/privileges listę `Functions`: wynik scalenia pakietu (Modules) z
 * uprawnieniami z metryki pracownika (model Magistratu: NavigationItem.UserRoleAvailability
 * + CustomUserAvailability). Front chowa wszystko spoza tej listy (CASL: `can("view", …)`).
 */
export enum EAppFunction {
  // Moduły pakietu Noty
  Desk = "desk",
  Incoming = "incoming",
  Outgoing = "outgoing",
  Cases = "cases",
  Drive = "drive",
  Shares = "shares",
  AddressBook = "addressBook",
  Tasks = "tasks",
  Chat = "chat",
  Budget = "budget",

  // Listy pism i obieg
  /** Magistrat: „Projekty pism". */
  LetterProjects = "letterProjects",
  /** Magistrat: „Wychodzące". */
  OutgoingLetters = "outgoingLetters",
  /** Magistrat: „Podpisywanie" — Kierownik, Zarząd albo osoba w ścieżce akceptacji. */
  AcceptanceSign = "acceptanceSign",
  Decrees = "decrees",

  // Moduły Magistratu
  /** Biuro podawcze — rola Biuro podawcze albo Administrator. */
  RegistryOffice = "registryOffice",
  /** Biuro rady (sesje, archiwum, obrady, radni) — prawo miejscowe albo administrator. */
  CouncilOffice = "councilOffice",
  /** Prawo miejscowe: projekty aktów i akty obowiązujące — dla wszystkich. */
  LocalLaw = "localLaw",
  /** Prawo miejscowe: „Do akceptacji". */
  LocalLawApproval = "localLawApproval",
  /** Prawo miejscowe: „Do publikacji", „Uchwalone", „Wnioski o publikację". */
  LocalLawManagement = "localLawManagement",
  /** Prawo miejscowe: „Uprawnienia". */
  LocalLawPermissions = "localLawPermissions",
  Registers = "registers",
  Reports = "reports",
  /** Program dziedzinowy RADIX. */
  Radix = "radix",
  /** Program dziedzinowy Podatki. */
  Taxes = "taxes",
  /** „Faktury KSeF" — osoby dekretujące faktury KSeF. */
  KSeFInvoices = "ksefInvoices",
  /** Księgowość (FK) — Główny księgowy albo administrator. */
  Fk = "fk",

  // Moduły Noty bez odpowiednika w Magistracie
  Waste = "waste",
  Procurement = "procurement",
}

/**
 * Moduł pakietu wymagany przez funkcję — WYŁĄCZNIE na wypadek, gdy /ui/privileges nie zwróci
 * `Functions` (błąd żądania albo starszy BE). Wtedy front nie ogranicza ról (jak fail-open
 * w BE), ale nadal chowa to, czego nie obejmuje pakiet — tak jak przed wprowadzeniem funkcji.
 */
export const APP_FUNCTION_MODULE: Partial<Record<EAppFunction, EAppModule>> =
  {
    [EAppFunction.Desk]: EAppModule.Desk,
    [EAppFunction.Incoming]: EAppModule.Incoming,
    [EAppFunction.Outgoing]: EAppModule.Outgoing,
    [EAppFunction.Cases]: EAppModule.Cases,
    [EAppFunction.Drive]: EAppModule.Drive,
    [EAppFunction.Shares]: EAppModule.Drive,
    [EAppFunction.AddressBook]: EAppModule.AddressBook,
    [EAppFunction.Tasks]: EAppModule.Tasks,
    [EAppFunction.Chat]: EAppModule.Workspace,
    [EAppFunction.Budget]: EAppModule.Budget,
  };
